import React, { useState } from 'react';
import { GroupsForm } from './GroupsForm';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Group } from '../../../../../../../constants/APIs';
import Validation from '../../../../../../../components/Validation';
export default function UpdateGroupsForm({ id, serviceProviders }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };
    // console.log('data', formmatedData);
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Group}/${id}`,
      data: formmatedData,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    }
    );
  };

  return (
    <div>
      <Button
        color="primary"
        size="xs"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <GroupsForm
          formLabel="Update Group"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          serviceProviders={serviceProviders}
        />
      )}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}
